import type { UserGetAppData } from '../../../../@api-client';
import type { OfflineBootstrapSnapshot } from '../../offline/session/offline-bootstrap-store';

export const resolveUserBootstrapData = (
  apiUser: UserGetAppData | undefined,
  snapshot: OfflineBootstrapSnapshot | undefined,
  isNative: boolean,
) => apiUser ?? (isNative ? snapshot?.user : undefined);
